export const colors = {
  LandingPage_Background: '#FFF8E7', // light saffron tint
  LandingPage_Description: '#5A3E1B', // earthy brown
  Button_Primary: '#FF6F00', // deep saffron (main CTA)
  Button_Secondary: '#F9A825', // mustard yellow (secondary CTA)
  Header_Background: "#FFEBCD", // soft cream
  Header_Content: '#4B2C0D', // dark brown
  Black: '#000000',
  Header: '#FF8F00', // orange header
  Header_Text: "#FFFFFF",
  Header_Text_back: "#E65100", // dark saffron
  Table_Header: '#FFECB3', // light saffron
  Action_Button_Back: '#D84315', // bright orange-red
  ALERT_BUTTON_GOTO_COLOR: "#FFF3E0", // subtle orange bg
  ALERT_BUTTON_CLOSE_COLOR: "#FFCDD2", // pink alert bg
  HEADER: '#BF360C', // very dark saffron
  SHADOW_LIGHT: "#FFE0B2", // soft shadow
  CAR_BOX_EVEN:'#FFF3E0',
  CAR_BOX_ODD:'#FFE082',
  CARD_LABEL:"#6D4C41", // deep brown
  CARD_DETAIL:"#FFFBE6",
  STATUS_COMPLETE:"#43A047", // green
  STATUS_CANCELED:"#E53935", // red
  STATUS_PENDING:"#FFB300", // bright amber
  ROW_SELECTED:"#FFEFD5",
  TABLE_BORDER:"rgba(255, 204, 128, 0.7)", // saffron border
  SUB_2:"#FF7043", // coral orange
  WALLET_CARD:"#E65100",
  WALLET_CARD_SHADOW:"#BCAAA4",
  FACEBOOK_COLOR:"#3b5998",
  BLUE:"#00acee",

  TAXIPRIMARY: "#E65100",
  TAXISECONDORY: "#FFF3E0",

  DELIVERYPRIMARY: "#FF9800",
  DELIVERYSECONDORY: "#FFE0B2",

  BIDTAXIPRIMARY: "#FF5722",
  BIDTAXISECONDORY: "#FFF8E1",

  TRANSPARENT: "transparent",
  WHITE: "#ffffff",
  BLACK: "#000000",
  RED: "#FF1E00",
  GREEN: "#0CAB03",
  YELLOW: "#FFD600",
  VIOLET:"#A755C2",
  SHADOW: "#e0b084", // earthy shadow
}
